import React, { useState } from 'react';

const Policies = ({ formData }) => {

  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [description, setDescription] = useState('');
  const [charLimit] = useState(3000);

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    if (value.length <= charLimit) {
      setDescription(value);
    }
  };

  const options = [
    "Selection One",
    "Selection Two",
    "Selection Three",
    "Selection Four",
    "Selection Five",
  ];

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleCheckboxChange = (value) => {
    setSelectedItems((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const handleCheckAll = () => {
    if (isAllChecked) {
      setSelectedItems([]);
    } else {
      setSelectedItems(options);
    }
    setIsAllChecked(!isAllChecked);
  };

  const getLabel = () => {
    const count = selectedItems.length;
    if (count === 0) return "Select";
    if (count === 1) return selectedItems[0];
    if (count === 2) return `${selectedItems[0]}, ${selectedItems[1]}`;
    return `${count} items selected`;
  };

  return (
    <div>
        <div className="clp-header">
            <h4 className='ws-title'>Policies</h4>
            <p className="ws-desc">Mention all the policies applicable at your property.</p>
        </div>

        <div className="add-room-section hmfsb">

          <div className="room-detail-box">
            <div>
              <p className='rdb-title mb-0'>Check-in & Check-out Time</p>
              <p className="label-hint">Specify the check-in & check-out time at your property</p>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="checkInTime" class="form-label">Check-in Time</label>
                  <select class="form-select">
                      <option value="FLEXIBLE">FLEXIBLE</option>
                      <option value="08:00 AM">08:00 AM</option>
                      <option value="09:00 AM">09:00 AM</option>
                      <option value="10:00 AM">10:00 AM</option>
                      <option value="11:00 AM">11:00 AM</option>
                      <option value="12:00 AM">12:00 AM</option>
                      <option value="01:00 PM">01:00 PM</option>
                      <option value="02:00 PM">02:00 PM</option>
                  </select>
                </div>
              </div>
              <div className='col-md-6'>
                <div class="form-box">
                  <label for="checkOutTime" class="form-label">Check-out Time</label>
                  <select class="form-select">
                      <option value="12:00 AM">12:00 AM</option>
                      <option value="01:00 AM">01:00 AM</option>
                      <option value="02:00 AM">02:00 AM</option>
                      <option value="03:00 AM">03:00 AM</option>
                      <option value="04:00 AM">04:00 AM</option>
                      <option value="05:00 AM">05:00 AM</option>
                      <option value="06:00 AM">06:00 AM</option>
                      <option value="07:00 AM">07:00 AM</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="room-detail-box">
            <div>
              <p className='rdb-title mb-0'>Cancellation Policy</p>
              <p className="label-hint">Select a suitable cancellation policy</p>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="cancellationPolicy" id="24hours" checked />
                  <label class="form-check-label" for="24hours">
                    Free cancellation upto 24 hrs
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="cancellationPolicy" id="48hours" />
                  <label class="form-check-label" for="48hours">
                    Free cancellation upto 48 hrs
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="cancellationPolicy" id="72hours" />
                  <label class="form-check-label" for="72hours">
                    Free cancellation upto 72 hrs
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="cancellationPolicy" id="nonRefundable" />
                  <label class="form-check-label" for="nonRefundable">
                    Non Refundable
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="room-detail-box">
            <div>
              <p className='rdb-title mb-0'>Property Rules(optional)</p>
              <p className="label-hint">Add property rules basis the requirement of your property listing</p>
            </div>
            
            <div className="polic-sub-section">
              <div className="hpsb">
                <p className="rdb-title">Guest Profile</p>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div>
                      <p>Do you allow unmarried couples?</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div>
                      <p>Do you allow guests below 18 years of age at your property?</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div>
                      <p>Groups with only male guests are allowed at your property?</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="polic-sub-section">
              <div className="hpsb">
                <p className="rdb-title">Acceptable Identity Proofs</p>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div class="form-box">
                    <label for="roomCount" class="form-label">Acceptable Identity Proofs</label>
                    <div className="dropdown" data-control="checkbox-dropdown">
                      <label className="dropdown-label form-select" onClick={toggleDropdown}>
                        {getLabel()}
                      </label>

                      {isOpen && (
                        <div className="dropdown-list">
                          <a
                            href="#"
                            className="dropdown-option"
                            data-toggle="check-all"
                            onClick={(e) => {
                              e.preventDefault();
                              handleCheckAll();
                            }}
                          >
                            {isAllChecked ? "Uncheck All" : "Check All"}
                          </a>
                          {options.map((option) => (
                            <label key={option} className="dropdown-option">
                              <input
                                type="checkbox"
                                name="dropdown-group"
                                value={option}
                                checked={selectedItems.includes(option)}
                                onChange={() => handleCheckboxChange(option)}
                              />
                              {option}
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div>
                      <p>Are IDs of the same city as the property allowed?</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="polic-sub-section">
              <div className="hpsb">
                <p className="rdb-title">Property Restrictions</p>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div>
                      <p>Is smoking allowed anywhere within the premises? (Select 'No' if it's not permitted, even in outdoor spaces like balconies or lawns, or any designated smoking area)</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div>
                      <p>Are Private parties or events allowed at the property?</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div>
                      <p>Can guests invite any outside visitors in the room during their stay?</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div>
                      <p>Is your property accessible for guests who use a wheelchair?</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="polic-sub-section">
              <div className="hpsb">
                <p className="rdb-title">Pet Policy</p>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div>
                      <p>Are Pets Allowed?</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div>
                      <p>Any Pet(s) living on the property?</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="polic-sub-section">
              <div className="hpsb">
                <p className="rdb-title">Checkin and Checkout Policies</p>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div>
                      <p>Do you have a 24-hour check-in?</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="polic-sub-section">
              <div className="hpsb">
                <p className="rdb-title">Extra Bed Policies</p>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div style={{width:'auto'}}>
                      <p>Do you provide bed to extra adults?</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Subject to Availability</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className='dypxbs'>
                    <div style={{width:'auto'}}>
                      <p>Do you provide bed to extra kids?</p>
                    </div>
                    <div class="extra-bed-radio">
                      <div className='exdrs'>
                        <label>
                          <input type="radio" name="radio" checked="" />
                          <span>No</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Yes</span>
                        </label>
                        <label>
                          <input type="radio" name="radio" />
                          <span>Subject to Availability</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="polic-sub-section">
              <div className="hpsb">
                <p className="rdb-title">Custom Policy</p>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='form-box'>
                    <label for="roomDesc" class="form-label">Custom Policy</label>
                    <textarea
                      className='form-control'
                      id='roomDesc'
                      rows={5}
                      value={description}
                      onChange={handleDescriptionChange}
                    />
                    <div className='hhtbs'>
                    {charLimit - (description?.length || 0)} characters available
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="polic-sub-section">
              <div className="hpsb">
                <p className="rdb-title">Meal rack prices</p>
              </div>
              <div className="form-box">
                <div class="row">
                  <label for="breakfast" class="col-sm-6">Breakfast</label>
                  <div class="col-sm-6">
                    <input type="text" readonly class="form-control" id="breakfast" value="0.00" />
                  </div>
                </div>
              </div>
              <div className="form-box">
                <div class="row">
                  <label for="lunch" class="col-sm-6">Lunch</label>
                  <div class="col-sm-6">
                    <input type="text" readonly class="form-control" id="lunch" value="0.00" />
                  </div>
                </div>
              </div>
              <div className="form-box">
                <div class="row">
                  <label for="dinner" class="col-sm-6">Dinner</label>
                  <div class="col-sm-6">
                    <input type="text" readonly class="form-control" id="dinner" value="0.00" />
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
    </div>
  );
};

export default Policies;
